export default "__VITE_ASSET__CgPxD_g0__"